import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {Observable, Subject} from 'rxjs';
import {ModalInterface} from '../../modal.interface';
import {ModalState} from '../../modal-state.enum';
import {ModalStateEvent} from '../../modal-state-event';

export type AvatarSecondaryAction = 'photos' | 'garage';
export type AvatarAction = 'profile' | AvatarSecondaryAction;

@Component({
  selector: 'app-avatar-actions',
  standalone: true,
  imports: [TranslateModule, ButtonModule, RippleModule],
  templateUrl: './avatar-actions.component.html',
})
export class AvatarActionsComponent implements ModalInterface {
  @Input() public data: {secondaryAction?: AvatarSecondaryAction};
  @Output() public actionSelected = new EventEmitter<AvatarAction>();
  public subject: Subject<ModalStateEvent>;
  public state: Observable<ModalStateEvent>;

  public get secondaryAction(): AvatarSecondaryAction { return this.data?.secondaryAction || 'photos'; }

  public choose(action: AvatarAction): void {
    this.actionSelected.emit(action);
    this.subject?.next(new ModalStateEvent(ModalState.SUCCESS, action));
  }
}
